import { Fragment } from 'react'

import { BodyP, HeadingS } from '@/components/Typography'

import type { CountdownStyleProps, CountdownTextColor, RemainingTime } from '../types'

import Counter from './Counter'

import { CountdownContainer, CountdownItem, HoursCountdownSeparator } from './styles'

interface Props extends Omit<CountdownStyleProps, 'labelColorModifier' | 'clockColorModifier'> {
  remainingTime: RemainingTime
  labelColor?: CountdownTextColor
  clockColor?: CountdownTextColor
  className?: string
}

const HoursCountdown = ({ remainingTime, labelColor, className, ...clockStyles }: Props) => {
  const formattedCountdown = () => {
    const hours = {
      digits: remainingTime.hours.split(''),
      label: 'Horas',
    }
    const minutes = {
      digits: remainingTime.minutes.split(''),
      label: 'Minutos',
    }
    const seconds = {
      digits: remainingTime.seconds.split(''),
      label: 'Segundos',
    }
    return [hours, minutes, seconds]
  }

  return (
    <CountdownContainer className={className}>
      {formattedCountdown().map((countItem, index) => (
        <Fragment key={index}>
          <CountdownItem>
            <Counter className="eu-sm-1" digits={countItem.digits} {...clockStyles} />
            <BodyP {...labelColor} emphasys>
              {countItem.label}
            </BodyP>
          </CountdownItem>
          {index !== formattedCountdown().length - 1 && (
            <HoursCountdownSeparator>
              <HeadingS {...labelColor} emphasys>
                :
              </HeadingS>
            </HoursCountdownSeparator>
          )}
        </Fragment>
      ))}
    </CountdownContainer>
  )
}

export default HoursCountdown
